<nav class="navbar navbar-expand-lg fixed-top">
  <a class="navbar-brand" routerLink="/">
    <span>
      <img
        class="logo"
        src="./assets/images/logo_new.png"
        (click)="setSiteName()" />
    </span>
    <!-- <span class="logo-span">{{ sitename }}</span> -->
    <span class="logo-span"></span>
  </a>

  <button class="navbar-toggler" (click)="isMenuCollapsed = !isMenuCollapsed">
    &#9776;
  </button>

  <div id="wwtp" class="collapse navbar-collapse" [ngbCollapse]="isMenuCollapsed">
    <ul class="navbar-nav ms-auto">
      <a class="nav-link" routerLink="/corporation/map-corp">
        <img src="./assets/images/map.jpg" alt="Map Icon" class="nav-icon1" />
        MAP
      </a>

      <a class="nav-link" routerLink="/corporation/corporate-dashboard">
        <img src="./assets/images/score.jpg" alt="Plant Icon" class="nav-icon" />
        CATEGORY
      </a>
      
      <li class="nav-item" ngbDropdown>
        <a class="nav-link" ngbDropdownToggle id="systemAdmin" role="button">
          <img src="./assets/images/statistics.jpg" alt="Icon" class="nav-icon" />
          STATISTICS <i class="fa fa-angle-down" aria-hidden="true"></i>
        </a>
        <ul ngbDropdownMenu>
          <li>
            <!-- <a ngbDropdownItem [routerLink]="['/mixdashboard/mix-report-list', activeCategory?.corp_cat_id || 0]" [queryParams]="{ type: 'category' }">CATEGORY</a> -->
            <a ngbDropdownItem [routerLink]="['/report-system/dashboard-group-list']" [queryParams]="{ type: 'corporate', subtype: 'category' }">CATEGORY</a>
          </li>
          <li>
            <a ngbDropdownItem [routerLink]="['/report-system/dashboard-group-list']" [queryParams]="{ type: 'corporate', subtype: 'plant' }">PLANT</a>
            <!-- <a ngbDropdownItem [routerLink]="['/mixdashboard/mix-report-list', activeCategory?.corp_cat_id || 0]" [queryParams]="{ type: 'plant' }">PLANT</a> -->
          </li>
        </ul>
      </li>


      <li class="nav-item" ngbDropdown>
        <a class="nav-link text-uppercase text-white" ngbDropdownToggle id="settingsAdmin" role="button">
          <img src="./assets/images/settings.jpg" alt="Settings Icon" class="nav-icon" />
          SETTINGS <i class="fa fa-angle-down" aria-hidden="true"></i>
        </a>
        <ul ngbDropdownMenu>
          <li>
            <a ngbDropdownItem (click)="setSiteName()" routerLink="/corporation/edit-corp">CORP SETTING</a>
          </li>
          <li>
            <a ngbDropdownItem (click)="setSiteName()" routerLink="/corporation/manage-corp-user">CORP USER SETTING</a>
          </li>
          <li>
            <a ngbDropdownItem (click)="setSiteName()" routerLink="/corporation/manage-corp-site">PLANT SETTING</a>
          </li>
          <li>
            <a ngbDropdownItem (click)="setSiteName()" routerLink="/corporation/categories-listing">CATEGORIES</a>
          </li>
        </ul>
      </li>

      <!-- Notification Icon -->
      <li class="nav-item notification-nav-item">
        <a class="nav-link notification-link" (click)="toggleNotificationPanel()" title="Notifications" style="cursor: pointer;">
          <i class="fa fa-bell notification-icon"></i>
          <span *ngIf="unreadNotificationCount > 0" class="notification-badge">{{ unreadNotificationCount }}</span>
        </a>
      </li>

      <li class="nav-item" ngbDropdown>
        <a class="nav-link" ngbDropdownToggle>
          <img src="./assets/images/avathar.jpg" class="avatar" />
        </a>
        <ul ngbDropdownMenu class="lgn-btn">
          <li>
            <a class="sub-dropdown-lgn" (click)="logout()"
              ><i class="fa fa-power-off"></i> Logout
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</nav>

<!-- Notification Panel Backdrop -->
<div 
  *ngIf="isNotificationPanelOpen" 
  class="notification-backdrop"
  (click)="onBackdropClick($event)">
</div>

<!-- Notification Panel -->
<div 
  class="notification-panel"
  [class.open]="isNotificationPanelOpen"
  [class.dark-mode]="notificationListComponent?.isDarkMode">
  <div class="notification-panel-header">
    <h4 class="notification-panel-title">
      <i class="fa fa-bell"></i> Notifications
      <span *ngIf="unreadNotificationCount > 0" class="badge badge-danger unread-badge-panel">
        {{ unreadNotificationCount }}
      </span>
    </h4>
    <div class="notification-panel-actions">
      <div class="theme-switch-container">
        <label class="theme-switch-label">
          <i class="fa fa-sun" [class.active]="!notificationListComponent?.isDarkMode"></i>
          <input 
            type="checkbox" 
            class="theme-switch"
            [checked]="notificationListComponent?.isDarkMode"
            (change)="notificationListComponent?.toggleTheme()"
            title="Toggle Dark/Light Mode">
          <span class="theme-switch-slider"></span>
          <i class="fa fa-moon" [class.active]="notificationListComponent?.isDarkMode"></i>
        </label>
      </div>
      <button class="btn btn-sm btn-close-panel" (click)="closeNotificationPanel()" title="Close">
        <i class="fa fa-times"></i>
      </button>
    </div>
  </div>
  <div class="notification-panel-content">
    <app-notification-list 
      #notificationListComponent
      [class.dark-mode]="notificationListComponent?.isDarkMode"
      (notificationClicked)="closeNotificationPanel()">
    </app-notification-list>
  </div>
</div>

